import { render, staticRenderFns } from "./SportCount.vue?vue&type=template&id=492cef79&scoped=true"
import script from "./SportCount.vue?vue&type=script&lang=js"
export * from "./SportCount.vue?vue&type=script&lang=js"
import style0 from "./SportCount.vue?vue&type=style&index=0&id=492cef79&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492cef79",
  null
  
)

export default component.exports